import { ApiService } from '@stores/ApiService';
import apiResponse from '@stores/ApiResponse';

export class SMSStatusStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  public async updateStatus(status: 'OPT-IN' | 'OPT-OUT') {
    try {
      if (status === 'OPT-IN') {
        const response = await this.api.put('user/sms/opt-in', {});
        return apiResponse.Success(response);
      } else {
        const response = await this.api.put('user/sms/opt-out', {});
        return apiResponse.Success(response);
      }
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
